import Plugin from 'src/plugin-system/plugin.class';

export default class PromotionBarPlugin extends Plugin {

    static options = {
        /**
         * cookie bar selector
         */
        cookieBarSelector: '.cookie-permission-container',

        scrollUpButtonSelector: '.js-scroll-up-button'
    };

    init() {
        this._cookieBar = document.querySelector(this.options.cookieBarSelector);
        this._scrollUpButton = document.querySelector(this.options.scrollUpButtonSelector);

        this._scrollUpButton.style['z-index'] = window.getComputedStyle(this.el).getPropertyValue('z-index') + 1;

        this._repositionPromotionBar();

        this._wasSticky = this._isSticky();
        if (this._wasSticky) {
            this._addPaddingToScrollUpButton();
        }

        this._registerEvents();
    }

    /**
     * register all needed events
     *
     * @private
     */
    _registerEvents() {
        this._cookieBar.$emitter.subscribe('showCookieBar', () => {
            this._repositionPromotionBar();
        });

        this._cookieBar.$emitter.subscribe('hideCookieBar', () => {
            this._repositionPromotionBar()
        });

        this._cookieBar.$emitter.subscribe('removeBodyPadding', () => {
            this._repositionPromotionBar()
        });

        window.addEventListener('resize', this._repositionPromotionBar.bind(this), {
            capture: true,
            passive: true
        });

        window.addEventListener('scroll', this._checkStickiness.bind(this), {
            capture: true,
            passive: true
        });
    }

    /**
     * repositions the promotion-bar relative to the cookie container
     */
    _repositionPromotionBar() {
        this.el.style.bottom = this._cookieBar.offsetHeight + 'px';
    }

    /**
     * checks for changes of the stickines of the promotion bar
     * and applies padding to the scroll-up button accordingly
     */
    _checkStickiness() {
        // if it was sticky on the bottom of the viewport and now is not
        // we need to remove extra padding from the scroll up button
        if (this._wasSticky && !this._isSticky()) {
            this._wasSticky = false;
            this._removePaddingFromScrollUpButton();

            return;
        }

        // if it was not sticky on the bottom of the viewport and now it is
        // we need to add extra padding from the scroll up button
        if (!this._wasSticky && this._isSticky()) {
            this._wasSticky = true;
            this._addPaddingToScrollUpButton();
        }
    }

    /**
     * determines if the promotion bar is sticky on the bottom of the viewport or not
     */
    _isSticky() {
        if (this.el.getBoundingClientRect().bottom + this._cookieBar.offsetHeight < (document.documentElement.clientHeight || window.innerHeight)) {
            return false;
        }

        return true;
    }

    _addPaddingToScrollUpButton() {
        this._scrollUpButton.style.paddingBottom = this.el.offsetHeight + 'px';
    }

    _removePaddingFromScrollUpButton() {
        this._scrollUpButton.style.paddingBottom = 0;
    }
}
